
import React, { useCallback, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { ReactComponent as CopyIcon } from "../../../../assets/icons/copy.svg";
import { ReactComponent as CheckIcon } from "../../../../assets/icons/check.svg";
import { Address, CopyButton, QrImageWrapper, Wrapper } from "./styles";

const FAVICON_URL = `/static/qr-logo.svg`;

type QrCodeProps = {
    value: string;
};

export default function QrCode({ value }: QrCodeProps) {
    const [copied, setCopied] = useState(false);

    const handleCopy = useCallback(async () => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            setCopied(false);
        }
    }, [value]);

    if (!value) {
        return null;
    }

    return (
        <Wrapper>
            <QrImageWrapper>
                <QRCodeCanvas
                    value={value}
                    size={200}
                    level="H"
                    marginSize={1}
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                    imageSettings={{
                        src: FAVICON_URL,
                        height: 40,
                        width: 40,
                        excavate: true,
                        crossOrigin: "anonymous",
                    }}
                />
            </QrImageWrapper>

            <Address>{value}</Address>

            <CopyButton type="button" onClick={handleCopy} aria-label="Copy address">
                <span>{copied ? "Copied" : "Copy"}</span>
                {copied ? <CheckIcon /> : <CopyIcon />}
            </CopyButton>
        </Wrapper>
    );
}
